import React from "react";
import { Message, Button, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { PermissionCheck } from "features/../../../shared/components/auth";
import { ImpersonatedUserPermissionCheck } from "modules/ImpersonatedUserPermissions";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";

const LockMessage = ({
  lockedByName,
  canUnlockSheet,
  canLockSheet,
  onUnlock,
  onLock,
}) => {
  const { t } = useTranslation("sheetTranslation", {
    keyPrefix: "LockMessage",
  });

  return (
    <Message color="orange" icon compact className="lock-message">
      <Icon name={"lock"} size="mini" />

      <Message.Content>
        <p>
          {canUnlockSheet
            ? t("SheetIsLocked_UserCanUnlock", { name: lockedByName })
            : t("SheetIsLocked_UserCannotUnlock", { name: lockedByName })}

          {canUnlockSheet && (
           <ImpersonatedUserPermissionCheck target={Targets.Sheet} action={Actions.ClearLock}>
              <Button color="orange" size="tiny" onClick={onUnlock}>
                {t("ClearLock")}
              </Button>
            </ImpersonatedUserPermissionCheck>
          )}
          {canLockSheet && (
            <Button color="orange" size="tiny" onClick={onLock}>
              {t("LockForMe")}
            </Button>
          )}
        </p>
      </Message.Content>
    </Message>
  );
};

export default LockMessage;
